// Rental-duration convention, shared by EVERY screen that shows or prices
// a rental period: the customer has the equipment on both the pickup day
// and the return day, so both count as billable days (standard for
// equipment rental — this is not hotel-style night counting). This is
// what actually determines pricing (the server's lib/totals.js uses the
// identical formula), so every display of a day count must come from
// here — never a private Math.ceil copy in a component.
//
// The backend has its own copy of this file (backend/lib/rentalDays.js);
// no shared package between the two repos, keep both in sync by hand.
export function daysBetween(from, to) {
  if (!from || !to) return 0;
  return Math.max(1, Math.round((new Date(to) - new Date(from)) / 86400000) + 1);
}

// How many billing periods a line covers, per rate type — the same
// arithmetic the pricing rules use (weeks = ceil(days/7), months = ceil(days/30)).
export function ratePeriods(rateType, days) {
  const d = Math.max(1, Number(days) || 1);
  if (rateType === 'week')  return Math.ceil(d / 7);
  if (rateType === 'month') return Math.ceil(d / 30);
  return d; // day (and the legacy 'hour' type, which bills per day)
}

// "3 days × $390.00/day", "2 weeks × $500.00/week". qty > 1 appends "× 2 units".
export function describeRateLine(line, days) {
  const rateType = line.rate_type || 'day';
  const n   = ratePeriods(rateType, days);
  const per = rateType === 'week' ? 'week' : rateType === 'month' ? 'month' : rateType === 'hour' ? 'hr' : 'day';
  const noun = per === 'hr' ? 'day' : per;
  const unit = Number(line.unit_price ?? line.rate_amount ?? 0);
  const money = '$' + unit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const qty = Number(line.quantity ?? line.qty ?? 1);
  return `${n} ${noun}${n === 1 ? '' : 's'} × ${money}/${per}${qty > 1 ? ` × ${qty} units` : ''}`;
}
